import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Mic, X } from "lucide-react";
import { voiceNeedsVoice } from "../../lib/api";
import { useVoiceReady } from "../ReadAloud";

const SNOOZE_KEY = "hv_needs_voice_snoozed_until";

// Vault home card: the signed-in writer's letters still read in a stand-in voice (same list as the Monday email).
export const NeedsVoiceNudge = () => {
  const ready = useVoiceReady();
  const [snoozed, setSnoozed] = useState(() => Number(localStorage.getItem(SNOOZE_KEY) || 0) > Date.now());
  const { data } = useQuery({ queryKey: ["needs-voice"], queryFn: voiceNeedsVoice, staleTime: 5 * 60_000, retry: false, enabled: ready && !snoozed });
  const n = data?.letters?.length || 0;
  if (snoozed || !n) return null;
  const snooze = () => { localStorage.setItem(SNOOZE_KEY, String(Date.now() + 7 * 86400 * 1000)); setSnoozed(true); };
  return (
    <section className="rounded-2xl border border-primary/30 bg-primary/5 p-4 sm:p-5 flex gap-3 items-start" data-testid="needs-voice-nudge">
      <span className="h-9 w-9 rounded-xl bg-primary/10 text-primary grid place-items-center shrink-0"><Mic className="h-4 w-4" /></span>
      <div className="min-w-0 flex-1">
        <div className="text-[10px] uppercase tracking-[0.2em] font-mono text-primary" data-testid="needs-voice-count">{n} letter{n === 1 ? "" : "s"} still need your voice</div>
        <p className="mt-1 text-sm text-muted-foreground">{data.letters.slice(0, 3).map((l) => `${l.title || "A letter"} for ${l.to_name}`).join(" · ")}{n > 3 ? ` · +${n - 3} more` : ""}</p>
        {data.can_clone
          ? <Link to="/planning?open=letters" className="mt-3 inline-flex rounded-full bg-primary text-primary-foreground px-4 py-1.5 text-xs hover:opacity-90 transition-opacity" data-testid="needs-voice-record">Record my voice</Link>
          : <p className="mt-2 text-xs text-amber-700" data-testid="needs-voice-blocked">{data.clone_block === "key" ? "Recording turns on once a full-access ElevenLabs key is added — your Administrator can do this in Admin." : "Recording your own voice needs an ElevenLabs plan with voice cloning."}</p>}
      </div>
      <button type="button" onClick={snooze} aria-label="Remind me next week" title="Remind me next week" className="h-7 w-7 rounded-full grid place-items-center text-muted-foreground hover:text-foreground hover:bg-background transition-colors shrink-0" data-testid="needs-voice-snooze"><X className="h-3.5 w-3.5" /></button>
    </section>
  );
};
